var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "article",
    { staticClass: "question-display" },
    [
      _c("strong", [
        _vm._v(_vm._s(_vm.$t("MAIN_CONTENT.confirmSubmission.pleaseConfirm")))
      ]),
      _vm._v(" "),
      _vm.timeLimitExceeded
        ? _c("div", { staticClass: "alert-panel alert-warning" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "alert-message" }, [
              _c("strong", [
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(
                      _vm.$t(
                        "MAIN_CONTENT.confirmSubmission.confirmSubmission_timesUp"
                      )
                    ) +
                    "\n\t\t\t"
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "MAIN_CONTENT.confirmSubmission.confirmSubmission_submitMessage"
                    )
                  )
                )
              ])
            ])
          ])
        : !!_vm.unansweredQuestions ||
          !!_vm.unansweredExtraCredit ||
          !!_vm.unsavedAnswers
        ? _c("div", { staticClass: "alert-panel alert-warning" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "alert-message" }, [
              _c("strong", [
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(
                      _vm.$t(
                        "MAIN_CONTENT.confirmSubmission.takeTester_itAppearsThatYouHave"
                      )
                    ) +
                    "\n\t\t\t"
                )
              ]),
              _vm._v(" "),
              _c("ul", [
                _vm.unsavedAnswers
                  ? _c("li", [
                      _c("b", [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(
                              _vm.$t(
                                "MAIN_CONTENT.confirmSubmission.takeTester_answersNotSaved",
                                { count: _vm.unsavedCount }
                              )
                            ) +
                            "\n\t\t\t\t\t"
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.unansweredQuestions
                  ? _c("li", [
                      _c("b", [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(
                              _vm.$t(
                                "MAIN_CONTENT.confirmSubmission.takeTester_questionsUnanswered",
                                { count: _vm.unansweredQuestions }
                              )
                            ) +
                            "\n\t\t\t\t\t"
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.unansweredExtraCredit
                  ? _c("li", [
                      _c("b", [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(
                              _vm.$t(
                                "MAIN_CONTENT.confirmSubmission.takeTester_extraCreditUnanswered",
                                { count: _vm.unansweredExtraCredit }
                              )
                            ) +
                            "\n\t\t\t\t\t"
                        )
                      ])
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(
                      _vm.$t(
                        "MAIN_CONTENT.confirmSubmission.returnToQuestionLinkBegin"
                      )
                    ) +
                    "\n\t\t\t\t"
                ),
                _c("a", { attrs: { href: "#question-nav" } }, [
                  _vm._v(
                    "\n\t\t\t\t\t" +
                      _vm._s(
                        _vm.$t(
                          "MAIN_CONTENT.confirmSubmission.returnToQuestionLinkMiddle"
                        )
                      ) +
                      "\n\t\t\t\t"
                  )
                ]),
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(
                      _vm.$t(
                        "MAIN_CONTENT.confirmSubmission.returnToQuestionLinkEnd"
                      )
                    ) +
                    "\n\t\t\t"
                )
              ])
            ])
          ])
        : _c("div", { staticClass: "alert-panel alert-info" }, [
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "alert-message" }, [
              _c("strong", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "MAIN_CONTENT.confirmSubmission.takeTester_readyToSubmit"
                    )
                  )
                )
              ]),
              _vm._v(" "),
              _vm.testPreview.TEST.SINGLE_SITTING_COMPLETION_FLG
                ? _c("p", [
                    _vm._v(
                      "\n\t\t\t\t" +
                        _vm._s(
                          _vm.$t(
                            "MAIN_CONTENT.confirmSubmission.takeTester_singleSittingMessage"
                          )
                        ) +
                        "\n\t\t\t"
                    )
                  ])
                : _vm._e()
            ])
          ]),
      _vm._v(" "),
      _c("test-buttons", {
        on: {
          "test-submitted": function($event) {
            return _vm.submitTest()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "alert-bar" }, [
      _c("i", { staticClass: "fas fa-exclamation-triangle" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "alert-bar" }, [
      _c("i", { staticClass: "fas fa-exclamation-triangle" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "alert-bar" }, [
      _c("i", { staticClass: "fas fa-info-circle" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }